export default __webpack_public_path__ + "static/media/pizza.496b8678.jpeg";